import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 q-pa-sm" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 grow q-pa-sm" }
const _hoisted_5 = { class: "col-6 grow q-pa-sm" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6 grow q-pa-sm" }
const _hoisted_8 = { class: "col-6 grow q-pa-sm" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-6 grow q-pa-sm" }
const _hoisted_11 = { class: "col-6 grow q-pa-sm" }
const _hoisted_12 = { class: "col-12 grow q-pa-sm" }
const _hoisted_13 = { class: "row justify-center q-my-md" }
const _hoisted_14 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_supplier_settings = _resolveComponent("supplier-settings")!
  const _component_supplier_address = _resolveComponent("supplier-address")!
  const _component_supplier_billing_address = _resolveComponent("supplier-billing-address")!
  const _component_supplier_payment_details = _resolveComponent("supplier-payment-details")!
  const _component_supplier_accounting_details = _resolveComponent("supplier-accounting-details")!
  const _component_supplier_registration_details = _resolveComponent("supplier-registration-details")!
  const _component_supplier_invoice_customization = _resolveComponent("supplier-invoice-customization")!
  const _component_supplier_api_settings = _resolveComponent("supplier-api-settings")!
  const _component_trash_icon = _resolveComponent("trash-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_supplier_settings, {
          supplier: _ctx.supplier,
          "onUpdate:supplier": _cache[0] || (_cache[0] = (supplierId, payload) => _ctx.$emit('update:supplier', supplierId, payload))
        }, null, 8, ["supplier"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_supplier_address, {
          supplier: _ctx.supplier,
          "onUpdate:supplier": _cache[1] || (_cache[1] = (supplierId, payload) => _ctx.$emit('update:supplier', supplierId, payload))
        }, null, 8, ["supplier"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_supplier_billing_address, {
          supplier: _ctx.supplier,
          "onUpdate:supplier": _cache[2] || (_cache[2] = (supplierId, payload) => _ctx.$emit('update:supplier', supplierId, payload))
        }, null, 8, ["supplier"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_supplier_payment_details, {
          supplier: _ctx.supplier,
          "onUpdate:supplier": _cache[3] || (_cache[3] = (supplierId, payload) => _ctx.$emit('update:supplier', supplierId, payload))
        }, null, 8, ["supplier"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_supplier_accounting_details, {
          supplier: _ctx.supplier,
          "onUpdate:supplier": _cache[4] || (_cache[4] = (supplierId, payload) => _ctx.$emit('update:supplier', supplierId, payload))
        }, null, 8, ["supplier"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_supplier_registration_details, {
          supplier: _ctx.supplier,
          "onUpdate:supplier": _cache[5] || (_cache[5] = (supplierId, payload) => _ctx.$emit('update:supplier', supplierId, payload))
        }, null, 8, ["supplier"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_supplier_invoice_customization, {
          supplier: _ctx.supplier,
          "onUpdate:supplier": _cache[6] || (_cache[6] = (supplierId, payload) => _ctx.$emit('update:supplier', supplierId, payload))
        }, null, 8, ["supplier"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_supplier_api_settings, {
          supplier: _ctx.supplier,
          "onUpdate:supplier": _cache[7] || (_cache[7] = (supplierId, payload) => _ctx.$emit('update:supplier', supplierId, payload))
        }, null, 8, ["supplier"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_q_btn, {
          class: "btn tertiary danger q-ml-sm",
          unelevated: "",
          flat: "",
          dense: "",
          square: "",
          padding: "6px",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('delete')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_trash_icon, { class: "trash-icon" }),
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "Delete supplier", -1))
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}